import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 22 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.125 12a6 6 0 1 0 0-12 6 6 0 0 0 0 12m-2.142 2.25a8.356 8.356 0 0 0-8.358 8.358c0 .769.623 1.392 1.392 1.392h18.216c.769 0 1.392-.623 1.392-1.392a8.356 8.356 0 0 0-8.358-8.358z" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }